import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UISegmentComponent } from './ui-segment.component';

@NgModule({
  declarations: [
    UISegmentComponent
  ],
  exports: [
    UISegmentComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class UISegmentModule { }
